import type { TableRef } from 'antd/es/table';
import type { Ref } from 'react';
import { Table, type TableProps } from 'antd';
import type { Require } from '@/types';

/**  Tamanho pequeno, bordas, e esconde o tooltip de ordenação que atrapalha */
export function TableDefault<T>(
    props: Require<
        Omit<TableProps<T>, 'size' | 'bordered' | 'showSorterTooltip'>,
        'columns' | 'rowKey'
    > & { ref?: Ref<TableRef> },
) {
    return (
        <Table<T>
            bordered={true}
            showSorterTooltip={false}
            size='small'
            {...props}
            pagination={
                props.pagination === false
                    ? false
                    : {
                          ...props.pagination,
                          showSizeChanger: {
                              showSearch: false,
                          },
                      }
            }
        />
    );
}

TableDefault.Summary = Table.Summary;
